import styled from "styled-components";
import { font } from "../components/shared/styles";

const Input = styled.input`
  font-family: ${font.body};
  font-style: normal;
  border-radius: 25px;
  padding-left: 20px;
  height: 53px;
  font-size: 20px;
  width: 100%;
  background-color: ${({ theme }) => theme.color.background.light};
  border: 0.5px solid ${({ theme }) => theme.color.text.secondary};
  &:focus,
  :active {
    outline: 0;
  }
  background: #e8e8e8;
  border: 0px;
  height: 40px;
`;

export default Input;
